<form [formGroup]="formPesquisa" class="search-form">
  <div class="form-row">
    <mat-form-field class="flex-item">
      <mat-label>Origem pedido</mat-label>
      <mat-select [(ngModel)]="origemDoPedidoSelecionada" formControlName="origemPedido">
        @for (origem of origensDoPedido; track $index) {
        <mat-option class="mat-options" [value]="origem.value">
          {{ origem.label }}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <div class="search-component custom-consulta">
      <app-consulta-customizada
        [labelDaDescricao]="'Situação'"
        [identificador]="'cntSituacaoPedidoVenda'"
        [campoFiltro]="['CD_SITUACAO','NM_SITUACAO']"
        [lookupExibicao]="['CD_SITUACAO', 'NM_SITUACAO']"
        [complementoConsulta]="''"
        (quantidadeItemConsultaEmitter)="null"
        (itemCosulta)="receberItemConsulta($event)"
        [campoRequerido]="false"
        class="larger-consulta"
      ></app-consulta-customizada>
    </div>

    <mat-form-field class="flex-item">
      <mat-label>Data inicial</mat-label>
      <input matInput [matDatepicker]="dataInicial" formControlName="dataInicial" />
      <mat-datepicker-toggle matSuffix [for]="dataInicial"></mat-datepicker-toggle>
      <mat-datepicker class="mat-calendar" #dataInicial></mat-datepicker>
      @if (formPesquisa.get('dataInicial').invalid) {
      <mat-error>Data inválida</mat-error>
      }
    </mat-form-field>

    <mat-form-field class="flex-item">
      <mat-label>Data final</mat-label>
      <input matInput [matDatepicker]="dataFinal" formControlName="dataFinal" />
      <mat-datepicker-toggle matSuffix [for]="dataFinal"></mat-datepicker-toggle>
      <mat-datepicker #dataFinal></mat-datepicker>
      @if (formPesquisa.get('dataFinal').invalid) {
      <mat-error>Data inválida</mat-error>
      }
    </mat-form-field>

    <button
      mat-raised-button
      color="primary"
      (click)="confirmar()"
      [disabled]="formPesquisa.invalid"
      class="flex-item custom-button"
    >
      OK
    </button>
  </div>
</form>
